module.exports = __webpack_public_path__ + "images/img_1_1-0c028f93fb.png";